import {convertCoordinates} from '@/api/util-coordinates';

class PhotoApiResponseModel {
  // #region Props

  // #endregion
  constructor({
    id,
    name,
    town,
    file,
    url,
    visibleApp,
    cx,
    cy,
  }) {
    return {
      id,
      name,
      town,
      file,
      photoUrl: url,
      coordinates: convertCoordinates(cx, cy),
      visible: visibleApp > 0,
    };
  }
}

export default PhotoApiResponseModel;
